import { IMessage, IEmailAddressInscription } from '../Models';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const NewsLetterService = {
    async getAllMessage(area: string): Promise<IMessage[]> {
        const response = await fetch('/Api/FlexMail/GetMessage?area=' + area, {
            method: 'GET',
            headers,
        });
        return await response.json();
    },
    async InscriptionMailList(
        emailAddress: IEmailAddressInscription
    ): Promise<number> {
        const response = await fetch('/Api/FlexMail/InscriptionMailList', {
            method: 'POST',
            body: JSON.stringify(emailAddress),
            headers,
        });
        return await response.json();
    },
};
